<template>
	<span
		:class="[
			'rounded-full uppercase font-bold font-display',
			{
				'bg-green-400 text-green-800': variant === 'green',
				'bg-yellow-400 text-yellow-900': variant === 'yellow',
				'bg-white text-gray-900': variant === 'white',
				'bg-purple-500 text-purple-50': variant === 'brand',
				'bg-gray-700 text-gray-50': variant === 'dark',
				'bg-gray-200 text-gray-600': variant === 'light',
				'text-functional-size-xs sm:text-functional-size-sm px-4 py-0.5': size === 'sm',
				'text-functional-size-md px-5 py-0.5': size === 'md',
				'text-functional-size-md px-5 py-2': size === 'lg',
			},
		]"
	>
		<slot />
	</span>
</template>

<script lang="ts" setup>
withDefaults(
	defineProps<{
		variant: 'green' | 'yellow' | 'white' | 'brand' | 'dark' | 'light';
		size?: 'sm' | 'md' | 'lg';
	}>(),
	{
		size: 'md',
	}
);
</script>
